import React from 'react';
import { forwardRef } from '@hub/design-system-base';
import { Text } from '@hub/text';
import { Link, LinkBox, LinkOverlay } from '@hub/link';
import { Stack } from '@hub/stack';
import { CloudinaryImage } from '../cloudinary-image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InlineDeckItem = forwardRef(({
  image,
  title,
  shortDescription,
  displayDate,
  callToAction,
  sx,
  imageRef,
  as,
  onClick
}, ref) => /*#__PURE__*/_jsxs(LinkBox, {
  ref: ref,
  sx: sx,
  as: as,
  onClick: onClick,
  children: [/*#__PURE__*/_jsx(CloudinaryImage, {
    ratio: "1",
    imageSetOrImage: image,
    imageRef: imageRef
  }), /*#__PURE__*/_jsxs(Stack, {
    gap: "spacing-xs",
    sx: {
      paddingTop: 'spacing-sm',
      paddingRight: 'spacing-sm'
    },
    children: [/*#__PURE__*/_jsx(LinkOverlay, {
      href: callToAction.url,
      children: /*#__PURE__*/_jsx(Text, {
        tone: "strong",
        children: title
      })
    }), shortDescription && /*#__PURE__*/_jsx(Text, {
      noOfLines: 2,
      children: shortDescription
    }), displayDate && /*#__PURE__*/_jsx(Text, {
      color: "quartz",
      children: displayDate
    }), !displayDate && !shortDescription && /*#__PURE__*/_jsx(Link, {
      hasUnderline: true,
      href: callToAction.url,
      children: callToAction.label
    })]
  })]
}));